import { render, staticRenderFns } from "./pricelist.vue?vue&type=template&id=256944d2&scoped=true&"
import script from "./pricelist.vue?vue&type=script&lang=js&"
export * from "./pricelist.vue?vue&type=script&lang=js&"
import style0 from "./pricelist.vue?vue&type=style&index=0&id=256944d2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "256944d2",
  null
  
)

export default component.exports